<div
  class="fleetStatusCheckbox"
  (click)="updateInclude()"
  [data-test]="'status-' + ppStatus + '-checkbox'"
>
  <pp-checkbox ppType="solid" ppSize="medium" [ppChecked]="ppInclude"></pp-checkbox>

  <span class="fleetStatusCheckbox__text">{{ status }} {{ 'points_lowercase' | ppTranslate }}</span>
</div>
